import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ReCAPTCHA from "react-google-recaptcha";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// All countries from database
const COUNTRIES = [
    { id: 1, name: 'Mexico' },
    { id: 2, name: 'United States' },
    { id: 3, name: 'Aruba' },
    { id: 4, name: 'Afghanistan' },
    { id: 5, name: 'Angola' },
    { id: 6, name: 'Anguilla' },
    { id: 7, name: 'Åland Islands' },
    { id: 8, name: 'Albania' },
    { id: 9, name: 'Andorra' },
    { id: 10, name: 'Netherlands Antilles' },
    { id: 11, name: 'United Arab Emirates' },
    { id: 12, name: 'Argentina' },
    { id: 13, name: 'Armenia' },
    { id: 14, name: 'American Samoa' },
    { id: 15, name: 'Antarctica' },
    { id: 16, name: 'French Southern Territories' },
    { id: 17, name: 'Antigua and Barbuda' },
    { id: 18, name: 'Australia' },
    { id: 19, name: 'Austria' },
    { id: 20, name: 'Azerbaijan' },
    { id: 21, name: 'Burundi' },
    { id: 22, name: 'Belgium' },
    { id: 23, name: 'Benin' },
    { id: 24, name: 'Burkina Faso' },
    { id: 25, name: 'Bangladesh' },
    { id: 26, name: 'Bulgaria' },
    { id: 27, name: 'Bahrain' },
    { id: 28, name: 'Bahamas' },
    { id: 29, name: 'Bosnia and Herzegovina' },
    { id: 30, name: 'Saint Barthélemy' },
    { id: 31, name: 'Belarus' },
    { id: 32, name: 'Belize' },
    { id: 33, name: 'Bermuda' },
    { id: 34, name: 'Bolivia, Plurinational State of' },
    { id: 35, name: 'Brazil' },
    { id: 36, name: 'Barbados' },
    { id: 37, name: 'Brunei Darussalam' },
    { id: 38, name: 'Bhutan' },
    { id: 39, name: 'Bouvet Island' },
    { id: 40, name: 'Botswana' },
    { id: 41, name: 'Central African Republic' },
    { id: 42, name: 'Canada' },
    { id: 43, name: 'Cocos (Keeling) Islands' },
    { id: 44, name: 'Switzerland' },
    { id: 45, name: 'Chile' },
    { id: 46, name: 'China' },
    { id: 47, name: 'Cote dIvoire' },
    { id: 48, name: 'Cameroon' },
    { id: 49, name: 'Congo, Democratic Republic' },
    { id: 50, name: 'Congo' },
    { id: 51, name: 'Cook Islands' },
    { id: 52, name: 'Colombia' },
    { id: 53, name: 'Comoros' },
    { id: 54, name: 'Cape Verde' },
    { id: 55, name: 'Costa Rica' },
    { id: 56, name: 'Cuba' },
    { id: 57, name: 'Christmas Island' },
    { id: 58, name: 'Cayman Islands' },
    { id: 59, name: 'Cyprus' },
    { id: 60, name: 'Czech Republic' },
    { id: 61, name: 'Germany' },
    { id: 62, name: 'Djibouti' },
    { id: 63, name: 'Dominica' },
    { id: 64, name: 'Denmark' },
    { id: 65, name: 'Dominican Republic' },
    { id: 66, name: 'Algeria' },
    { id: 67, name: 'Ecuador' },
    { id: 68, name: 'Egypt' },
    { id: 69, name: 'Eritrea' },
    { id: 70, name: 'Western Sahara' },
    { id: 71, name: 'Spain' },
    { id: 72, name: 'Estonia' },
    { id: 73, name: 'Ethiopia' },
    { id: 74, name: 'Finland' },
    { id: 75, name: 'Fiji' },
    { id: 76, name: 'Falkland Islands (Malvinas)' },
    { id: 77, name: 'France' },
    { id: 78, name: 'Faroe Islands' },
    { id: 79, name: 'Micronesia, Federated States of' },
    { id: 80, name: 'Gabon' },
    { id: 81, name: 'United Kingdom' },
    { id: 82, name: 'Georgia' },
    { id: 83, name: 'Guernsey' },
    { id: 84, name: 'Ghana' },
    { id: 85, name: 'Gibraltar' },
    { id: 86, name: 'Guinea' },
    { id: 87, name: 'Guadeloupe' },
    { id: 88, name: 'Gambia' },
    { id: 89, name: 'Guinea-Bissau' },
    { id: 90, name: 'Equatorial Guinea' },
    { id: 91, name: 'Greece' },
    { id: 92, name: 'Grenada' },
    { id: 93, name: 'Greenland' },
    { id: 94, name: 'Guatemala' },
    { id: 95, name: 'French Guiana' },
    { id: 96, name: 'Guam' },
    { id: 97, name: 'Guyana' },
    { id: 98, name: 'Hong Kong' },
    { id: 99, name: 'Heard Island and McDonald Islands' },
    { id: 100, name: 'Honduras' },
    { id: 101, name: 'Croatia' },
    { id: 102, name: 'Haiti' },
    { id: 103, name: 'Hungary' },
    { id: 104, name: 'Indonesia' },
    { id: 105, name: 'Isle of Man' },
    { id: 106, name: 'India' },
    { id: 107, name: 'British Indian Ocean Territory' },
    { id: 108, name: 'Ireland' },
    { id: 109, name: 'Iran, Islamic Republic of' },
    { id: 110, name: 'Iraq' },
    { id: 111, name: 'Iceland' },
    { id: 112, name: 'Israel' },
    { id: 113, name: 'Italy' },
    { id: 114, name: 'Jamaica' },
    { id: 115, name: 'Jersey' },
    { id: 116, name: 'Jordan' },
    { id: 117, name: 'Japan' },
    { id: 118, name: 'Kazakhstan' },
    { id: 119, name: 'Kenya' },
    { id: 120, name: 'Kyrgyzstan' },
    { id: 121, name: 'Cambodia' },
    { id: 122, name: 'Kiribati' },
    { id: 123, name: 'Saint Kitts and Nevis' },
    { id: 124, name: 'Korea, Republic of' },
    { id: 125, name: 'Kuwait' },
    { id: 126, name: 'Lao People Democratic Republic' },
    { id: 127, name: 'Lebanon' },
    { id: 128, name: 'Liberia' },
    { id: 129, name: 'Libyan Arab Jamahiriya' },
    { id: 130, name: 'Saint Lucia' },
    { id: 131, name: 'Liechtenstein' },
    { id: 132, name: 'Sri Lanka' },
    { id: 133, name: 'Lesotho' },
    { id: 134, name: 'Lithuania' },
    { id: 135, name: 'Luxembourg' },
    { id: 136, name: 'Latvia' },
    { id: 137, name: 'Macao' },
    { id: 138, name: 'Saint Martin (French part)' },
    { id: 139, name: 'Morocco' },
    { id: 140, name: 'Monaco' },
    { id: 141, name: 'Moldova, Republic of' },
    { id: 142, name: 'Madagascar' },
    { id: 143, name: 'Maldives' },
    { id: 144, name: 'Marshall Islands' },
    { id: 145, name: 'Macedonia' },
    { id: 146, name: 'Mali' },
    { id: 147, name: 'Malta' },
    { id: 148, name: 'Myanmar' },
    { id: 149, name: 'Montenegro' },
    { id: 150, name: 'Mongolia' },
    { id: 151, name: 'Northern Mariana Islands' },
    { id: 152, name: 'Mozambique' },
    { id: 153, name: 'Mauritania' },
    { id: 154, name: 'Montserrat' },
    { id: 155, name: 'Martinique' },
    { id: 156, name: 'Mauritius' },
    { id: 157, name: 'Malawi' },
    { id: 158, name: 'Malaysia' },
    { id: 159, name: 'Mayotte' },
    { id: 160, name: 'Namibia' },
    { id: 161, name: 'New Caledonia' },
    { id: 162, name: 'Niger' },
    { id: 163, name: 'Norfolk Island' },
    { id: 164, name: 'Nigeria' },
    { id: 165, name: 'Nicaragua' },
    { id: 166, name: 'Niue' },
    { id: 167, name: 'Netherlands' },
    { id: 168, name: 'Norway' },
    { id: 169, name: 'Nepal' },
    { id: 170, name: 'Nauru' },
    { id: 171, name: 'New Zealand' },
    { id: 172, name: 'Oman' },
    { id: 173, name: 'Pakistan' },
    { id: 174, name: 'Panama' },
    { id: 175, name: 'Pitcairn' },
    { id: 176, name: 'Peru' },
    { id: 177, name: 'Philippines' },
    { id: 178, name: 'Palau' },
    { id: 179, name: 'Papua New Guinea' },
    { id: 180, name: 'Poland' },
    { id: 181, name: 'Puerto Rico' },
    { id: 182, name: 'Korea, Democratic Republic' },
    { id: 183, name: 'Portugal' },
    { id: 184, name: 'Paraguay' },
    { id: 185, name: 'Palestinian Territory, Occupied' },
    { id: 186, name: 'French Polynesia' },
    { id: 187, name: 'Qatar' },
    { id: 188, name: 'Réunion' },
    { id: 189, name: 'Romania' },
    { id: 190, name: 'Russian Federation' },
    { id: 191, name: 'Rwanda' },
    { id: 192, name: 'Saudi Arabia' },
    { id: 193, name: 'Sudan' },
    { id: 194, name: 'Senegal' },
    { id: 195, name: 'Singapore' },
    { id: 196, name: 'South Georgia and Sandwich Isl' },
    { id: 197, name: 'Saint Helena, Ascension and Tristan' },
    { id: 198, name: 'Svalbard and Jan Mayen' },
    { id: 199, name: 'Solomon Islands' },
    { id: 200, name: 'Sierra Leone' },
    { id: 201, name: 'El Salvador' },
    { id: 202, name: 'San Marino' },
    { id: 203, name: 'Somalia' },
    { id: 204, name: 'Saint Pierre and Miquelon' },
    { id: 205, name: 'Serbia' },
    { id: 206, name: 'Sao Tome and Principe' },
    { id: 207, name: 'Suriname' },
    { id: 208, name: 'Slovakia' },
    { id: 209, name: 'Slovenia' },
    { id: 210, name: 'Sweden' },
    { id: 211, name: 'Swaziland' },
    { id: 212, name: 'Seychelles' },
    { id: 213, name: 'Syrian Arab Republic' },
    { id: 214, name: 'Turks and Caicos Islands' },
    { id: 215, name: 'Chad' },
    { id: 216, name: 'Togo' },
    { id: 217, name: 'Thailand' },
    { id: 218, name: 'Tajikistan' },
    { id: 219, name: 'Tokelau' },
    { id: 220, name: 'Turkmenistan' },
    { id: 221, name: 'Timor-Leste' },
    { id: 222, name: 'Tonga' },
    { id: 223, name: 'Trinidad and Tobago' },
    { id: 224, name: 'Tunisia' },
    { id: 225, name: 'Turkey' },
    { id: 226, name: 'Tuvalu' },
    { id: 227, name: 'Taiwan, Province of China' },
    { id: 228, name: 'Tanzania, United Republic of' },
    { id: 229, name: 'Uganda' },
    { id: 230, name: 'Ukraine' },
    { id: 231, name: 'United States Minor Outlying Isl' },
    { id: 232, name: 'Uruguay' },
    { id: 233, name: 'Uzbekistan' },
    { id: 234, name: 'Holy See (Vatican City State)' },
    { id: 235, name: 'Saint Vincent and the Grenadines' },
    { id: 236, name: 'Venezuela, Bolivarian Republic of' },
    { id: 237, name: 'Virgin Islands, British' },
    { id: 238, name: 'Virgin Islands, U.S.' },
    { id: 239, name: 'Viet Nam' },
    { id: 240, name: 'Vanuatu' },
    { id: 241, name: 'Wallis and Futuna' },
    { id: 242, name: 'Samoa' },
    { id: 243, name: 'Yemen' },
    { id: 244, name: 'South Africa' },
    { id: 245, name: 'Zambia' },
    { id: 246, name: 'Zimbabwe' },
];

// Mexican states (IDs 1-32)
const MEXICAN_STATES = [
    { id: 1, name: 'Aguascalientes' },
    { id: 2, name: 'Baja California' },
    { id: 3, name: 'Baja California Sur' },
    { id: 4, name: 'Campeche' },
    { id: 5, name: 'Chiapas' },
    { id: 6, name: 'Chihuahua' },
    { id: 7, name: 'Coahuila' },
    { id: 8, name: 'Colima' },
    { id: 9, name: 'Ciudad de México' },
    { id: 10, name: 'Durango' },
    { id: 11, name: 'Guanajuato' },
    { id: 12, name: 'Guerrero' },
    { id: 13, name: 'Hidalgo' },
    { id: 14, name: 'Jalisco' },
    { id: 15, name: 'Estado de México' },
    { id: 16, name: 'Michoacán' },
    { id: 17, name: 'Morelos' },
    { id: 18, name: 'Nayarit' },
    { id: 19, name: 'Nuevo León' },
    { id: 20, name: 'Oaxaca' },
    { id: 21, name: 'Puebla' },
    { id: 22, name: 'Querétaro' },
    { id: 23, name: 'Quintana Roo' },
    { id: 24, name: 'San Luis Potosí' },
    { id: 25, name: 'Sinaloa' },
    { id: 26, name: 'Sonora' },
    { id: 27, name: 'Tabasco' },
    { id: 28, name: 'Tamaulipas' },
    { id: 29, name: 'Tlaxcala' },
    { id: 30, name: 'Veracruz' },
    { id: 31, name: 'Yucatán' },
    { id: 32, name: 'Zacatecas' },
];

// US states (IDs 33-82)
const US_STATES = [
    { id: 33, name: 'Alaska', code: 'AK' },
    { id: 34, name: 'Alabama', code: 'AL' },
    { id: 35, name: 'Arkansas', code: 'AR' },
    { id: 36, name: 'Arizona', code: 'AZ' },
    { id: 37, name: 'California', code: 'CA' },
    { id: 38, name: 'Colorado', code: 'CO' },
    { id: 39, name: 'Connecticut', code: 'CT' },
    { id: 40, name: 'Delaware', code: 'DE' },
    { id: 41, name: 'Florida', code: 'FL' },
    { id: 42, name: 'Georgia', code: 'GA' },
    { id: 43, name: 'Hawaii', code: 'HI' },
    { id: 44, name: 'Iowa', code: 'IA' },
    { id: 45, name: 'Idaho', code: 'ID' },
    { id: 46, name: 'Illinois', code: 'IL' },
    { id: 47, name: 'Indiana', code: 'IN' },
    { id: 48, name: 'Kansas', code: 'KS' },
    { id: 49, name: 'Kentucky', code: 'KY' },
    { id: 50, name: 'Louisiana', code: 'LA' },
    { id: 51, name: 'Massachusetts', code: 'MA' },
    { id: 52, name: 'Maryland', code: 'MD' },
    { id: 53, name: 'Maine', code: 'ME' },
    { id: 54, name: 'Michigan', code: 'MI' },
    { id: 55, name: 'Minnesota', code: 'MN' },
    { id: 56, name: 'Missouri', code: 'MO' },
    { id: 57, name: 'Mississippi', code: 'MS' },
    { id: 58, name: 'Montana', code: 'MT' },
    { id: 59, name: 'North Carolina', code: 'NC' },
    { id: 60, name: 'North Dakota', code: 'ND' },
    { id: 61, name: 'Nebraska', code: 'NE' },
    { id: 62, name: 'New Hampshire', code: 'NH' },
    { id: 63, name: 'New Jersey', code: 'NJ' },
    { id: 64, name: 'New Mexico', code: 'NM' },
    { id: 65, name: 'Nevada', code: 'NV' },
    { id: 66, name: 'New York', code: 'NY' },
    { id: 67, name: 'Ohio', code: 'OH' },
    { id: 68, name: 'Oklahoma', code: 'OK' },
    { id: 69, name: 'Oregon', code: 'OR' },
    { id: 70, name: 'Pennsylvania', code: 'PA' },
    { id: 71, name: 'Rhode Island', code: 'RI' },
    { id: 72, name: 'South Carolina', code: 'SC' },
    { id: 73, name: 'South Dakota', code: 'SD' },
    { id: 74, name: 'Tennessee', code: 'TN' },
    { id: 75, name: 'Texas', code: 'TX' },
    { id: 76, name: 'Utah', code: 'UT' },
    { id: 77, name: 'Virginia', code: 'VA' },
    { id: 78, name: 'Vermont', code: 'VT' },
    { id: 79, name: 'Washington', code: 'WA' },
    { id: 80, name: 'Wisconsin', code: 'WI' },
    { id: 81, name: 'West Virginia', code: 'WV' },
    { id: 82, name: 'Wyoming', code: 'WY' },
];

// Helper function to get N/A state ID for a country
const getNAStateId = (countryId: number) => {
    // N/A states start at ID 83 for country 3, so formula is: 83 + (countryId - 3)
    if (countryId <= 2) return null;
    return 83 + (countryId - 3);
};

const TournamentDetail = () => {
    const { state } = useLocation();
    const tournament = state?.tournament;
    const navigate = useNavigate();
    const [captchaQuestion, setCaptchaQuestion] = useState('');
    const [captchaExpected, setCaptchaExpected] = useState<number | null>(null);
    const [captchaInput, setCaptchaInput] = useState('');
    const [discountCode, setDiscountCode] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [form, setForm] = useState({
        firstName: '',
        lastName: '',
        street: '',
        apt: '',
        city: '',
        state: '',
        country: '',
        zip: '',
        dob: '',
        phone: '',
        email: '',
        ssn: '',
        usbc: '',
		bowlerType: 0,
        bowlerHand: 'r',
        bowlerGender: 'm',
        captcha: '',
    });
    useEffect(() => {
        if (showModal) {
            const a = Math.floor(Math.random() * 10) + 1;
            const b = Math.floor(Math.random() * 10) + 1;
            setCaptchaQuestion(`What is ${a} + ${b}?`);
            setCaptchaExpected(a + b);
            setCaptchaInput('');
        }
    }, [showModal]);
    const [submitted, setSubmitted] = useState(false);
	
    const [spResult, setSpResult] = useState<any>(null);
    const handleFormChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };
    const handleFormSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        // Send form data to backend - convert string IDs to integers
        const formDataToSend = {
            ...form,
            country: Number(form.country),
            state: Number(form.state),
            bowlerType: Number(form.bowlerType),
        };
        
        console.log('🔍 Form data being sent to backend:', formDataToSend);
        console.log('Country (string):', form.country, '→ (number):', formDataToSend.country);
        console.log('State (string):', form.state, '→ (number):', formDataToSend.state);
        
        const res = await fetch(`${BACKEND_URL}/api/email-registration`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formDataToSend),
        });
        if (res.ok) {
            const data = await res.json();
            setSpResult(data.result);
            setSubmitted(true);
            // Optionally reset form
        } else {
            alert('There was an error sending your registration.');
        }
    };

    const [search, setSearch] = useState('');
    const [results, setResults] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const isValidSSN = /^\d{9}$/.test(form.ssn.replace(/\D/g, ''));
    if (!tournament) return <div>No tournament data.</div>;

    const handleSearch = async () => {
        setLoading(true);
        let url = `${BACKEND_URL}/api/jugadores?`;
        if (!isNaN(Number(search))) {
            url += `tatid=${encodeURIComponent(search)}`;
        } else {
            url += `lastname=${encodeURIComponent(search)}`;
        }
        const res = await fetch(url);
        const data = await res.json();
        setResults(data);
        setLoading(false);
    };

    const handleSelectJugador = (jugador: any, tournament: any) => {
        navigate('/turnos-signup', { state: { jugador, tournament, discountCode } });
    };



    return (
        <div className="p-8 min-h-screen">
            <div className="flex items-center bg-white shadow-md rounded-lg px-6 py-4 mb-6 w-full">
                <button
                    onClick={() => navigate(-1)}
                    className="mr-4 p-2 rounded hover:bg-blue-100 transition text-blue-600 font-semibold"
                >
                    &larr; Back
                </button>
                <h1 className="text-lg sm:text-3xl font-bold text-black-700">{tournament.nombre}</h1>
            </div>

            <div className="bg-white shadow rounded-lg p-6 max-w-lg">
                <label className="block text-gray-400 mb-2 text-sm">
                    New to TAT?{' '}
                    <button
                        className="text-blue-600 underline hover:text-blue-800"
                        onClick={() => setShowModal(true)}
                        type="button"
                    >
                        Click here to be registered as a <b>NEW</b> TAT bowler.
                    </button>
                </label>

                <input
                    type="text"
                    value={discountCode}
                    onChange={e => setDiscountCode(e.target.value)}
                    className="flex-1 border border-gray-300 rounded px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-200"
                    placeholder="Group Code (optional)"
                />
                <label className="block text-gray-700 mb-2 font-semibold">TAT ID or Last Name</label>
                <div className="flex gap-2 mb-4">
                    <input
                        type="text"
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        className="flex-1 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-200"
                        placeholder="Enter TAT ID or Last Name"
                    />
                    <button
                        onClick={handleSearch}
                        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
                        disabled={loading}
                    >
                        {loading ? 'Searching...' : 'Search'}
                    </button>
                </div>

                <ul>
                    {(Array.isArray(results) ? results : []).map(j => (
                        <li
                            key={j.CLAVE}
                            className="p-3 rounded hover:bg-blue-100 cursor-pointer transition"
                            onClick={() => handleSelectJugador(j, tournament)}
                        >
                            <span className="font-semibold">{j.FICHANAL}</span> - {j.NOMBRECOMPLETO}
                        </li>
                    ))}
                </ul>
            </div>
            {/* Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-lg" style={{ maxHeight: '80vh' }}>
                        {!submitted ? (
                            <>
                                {/* Fixed Header */}
                                <div className="bg-white border-b px-8 py-4 rounded-t-lg">
                                    <h2 className="text-xl font-bold">TAT Bowler Registration</h2>
                                </div>

                                {/* Scrollable Content */}
                                <div className="px-8 py-4" style={{ height: 'calc(80vh - 140px)', overflowY: 'auto' }}>
                                    <form onSubmit={handleFormSubmit} className="space-y-3">
                                        <input name="firstName" value={form.firstName} onChange={handleFormChange} required className="w-full border px-3 py-2 rounded" placeholder="First Name" />
                                        <input name="lastName" value={form.lastName} onChange={handleFormChange} required className="w-full border px-3 py-2 rounded" placeholder="Last Name" />
                                        <input
                                            name="street"
                                            value={form.street}
                                            onChange={handleFormChange}
                                            required
                                            className="w-full border px-3 py-2 rounded"
                                            placeholder="Street Address"
                                        />
                                        <input
                                            name="apt"
                                            value={form.apt}
                                            onChange={handleFormChange}
                                            className="w-full border px-3 py-2 rounded"
                                            placeholder="Apt, Suite, Unit (optional)"
                                        />
                                        <input
                                            name="city"
                                            value={form.city}
                                            onChange={handleFormChange}
                                            required
                                            className="w-full border px-3 py-2 rounded"
                                            placeholder="City"
                                        />
                                        <div className="flex gap-2">
                                            <select
                                                name="country"
                                                value={form.country}
                                                onChange={(e) => {
                                                    handleFormChange(e);
                                                    // Reset state when country changes
                                                    setForm(prev => ({ ...prev, state: '' }));
                                                }}
                                                required
                                                className="flex-1 border px-3 py-2 rounded bg-white"
                                            >
                                                <option value="">Select Country</option>
                                                {COUNTRIES.map(country => (
                                                    <option key={country.id} value={country.id.toString()}>
                                                        {country.name}
                                                    </option>
                                                ))}
                                            </select>
                                            <select
                                                name="state"
                                                value={form.state}
                                                onChange={handleFormChange}
                                                required
                                                className="flex-1 border px-3 py-2 rounded bg-white"
                                                disabled={!form.country}
                                            >
                                                <option value="">Select State</option>
                                                {form.country === '1' && MEXICAN_STATES.map(state => (
                                                    <option key={state.id} value={state.id.toString()}>
                                                        {state.name}
                                                    </option>
                                                ))}
                                                {form.country === '2' && US_STATES.map(state => (
                                                    <option key={state.id} value={state.id.toString()}>
                                                        {state.code}
                                                    </option>
                                                ))}
                                                {form.country && form.country !== '1' && form.country !== '2' && (
                                                    <option value={(getNAStateId(Number(form.country)) || '').toString()}>
                                                        N/A
                                                    </option>
                                                )}
                                            </select>
                                        </div>
                                        <input
                                            name="zip"
                                            value={form.zip}
                                            onChange={handleFormChange}
                                            required
                                            className="w-full border px-3 py-2 rounded"
                                            placeholder="Zip Code"
                                        />
										<div className="text-md">Date of Birth</div>
                                        <input name="dob" value={form.dob} onChange={handleFormChange} required className="w-full border px-3 py-2 rounded" placeholder="Date of Birth" type="date" />
                                        <input name="phone" value={form.phone} onChange={handleFormChange} required className="w-full border px-3 py-2 rounded" placeholder="Phone Number" />
                                        <input name="email" value={form.email} onChange={handleFormChange} required className="w-full border px-3 py-2 rounded" placeholder="Email" type="email" />
                                        <div className="text-gray-400 text-xs">If international please enter 111111111 for SSN</div>
                                        <input name="ssn" value={form.ssn} onChange={handleFormChange} required className="w-full border px-3 py-2 rounded" placeholder="SSN" />
                                        {form.ssn && !isValidSSN && (
                                            <div className="text-red-600 text-sm">SSN must be exactly 9 digits.</div>
                                        )}
                                        <input name="usbc" value={form.usbc} onChange={handleFormChange} className="w-full border px-3 py-2 rounded" placeholder="USBC #" />
                                        <select
                                            name="bowlerType"
                                            value={form.bowlerType}
                                            required
                                            onChange={handleFormChange}
                                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-200 bg-white"
                                        >
                                            <option value={0}>Select Bowler Type</option>
                                            <option value={1}>Traditional</option>
                                            <option value={2}>Two Handed</option>
                                            <option value={3}>Chopper</option>
                                            <option value={4}>Backer</option>
                                        </select>
                                        <select
                                            name="bowlerHand"
                                            value={form.bowlerHand}
                                            required
                                            onChange={handleFormChange}
                                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-200 bg-white"
                                        >
                                            <option value={''}>Select Bowler Hand</option>
                                            <option value={'L'}>Left</option>
                                            <option value={'R'}>Right</option>
                                        </select>
                                        <select
                                            name="bowlerGender"
                                            value={form.bowlerGender}
                                            required
                                            onChange={handleFormChange}
                                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-200 bg-white"
                                        >
                                            <option value={''}>Select Bowler Gender</option>
                                            <option value={'M'}>Male</option>
                                            <option value={'F'}>Female</option>
                                        </select>
                                        <input
                                            name="captcha"
                                            value={captchaInput}
                                            onChange={e => setCaptchaInput(e.target.value)}
                                            required
                                            className="w-full border px-3 py-2 rounded"
                                            placeholder={captchaQuestion}
                                        />
                                        <div className="flex justify-end gap-2 pt-4 border-t mt-4">
                                            <button
                                                type="button"
                                                className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
                                                onClick={() => setShowModal(false)}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="submit"
                                                className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
                                                disabled={
                                                    Number(captchaInput) !== captchaExpected ||
                                                    !isValidSSN ||
                                                    form.bowlerType === 0 ||
                                                    form.bowlerHand === '' ||
                                                    form.bowlerGender === ''
                                                }
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </>
                        ) : (
                            <div className="text-center">
                                {/* CHECK IF IT'S AN ERROR CODE (1-2) OR SUCCESS (0) */}
                                {spResult >= 1 && spResult <= 2 ? (
                                    // ERROR CASE - Error codes 1 and 2
                                    <>
                                        <h2 className="text-xl font-bold mb-4 text-red-700">Registration Error</h2>
                                        <p className="m-4">
                                            {spResult === 1 && "A player with this name and date of birth already exists. If you can't remember your TAT ID please search by last name instead."}<br />
                                            {spResult === 2 && "Date of birth is required for registration."}
                                        </p>
                                    </>
                                ) : spResult === 0 ? (
                                    // ERROR CASE - Should never happen (0 means success but no TAT ID?)
                                    <>
                                        <h2 className="text-xl font-bold mb-4 text-red-700">Registration Error</h2>
                                        <p className="mb-4">
                                            Registration completed but no TAT ID was returned.<br />
                                            Please contact support at <b>bowlingtat@gmail.com</b>.
                                        </p>
                                    </>
                                ) : (
                                    // SUCCESS CASE - Any other number is the TAT ID
                                    <>
                                        <h2 className="text-xl font-bold mb-4 text-green-700">🎳 Thank you for registering!</h2>
                                        <p className="mb-4">
                                            <strong>Your TAT ID is: {spResult}</strong><br />
                                            Please use this ID or search your last name to complete tournament registration.
                                        </p>
                                    </>
                                )}

                                <button
                                    className="px-4 py-2 mb-2 rounded bg-blue-600 text-white hover:bg-blue-700"
                                    onClick={() => {
                                        setShowModal(false);
                                        setSubmitted(false);
                                        setSpResult(null); // ADD THIS LINE
                                        setForm({
                                            firstName: '',
                                            lastName: '',
                                            street: '',
                                            apt: '',
                                            city: '',
                                            state: '',
                                            country: '',
                                            zip: '',
                                            dob: '',
                                            phone: '',
                                            email: '',
                                            ssn: '',
                                            usbc: '',
                                            bowlerType: 0,
                                            bowlerHand: 'r',
                                            bowlerGender: 'm',
                                            captcha: '',
                                        });
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default TournamentDetail;